import type { ComponentProps } from 'react';
import { FieldInfo, hasFieldError, useFieldContext, useIsFieldOptional } from './shared';
import { FieldLabelRow } from './field-label-row';
import { Input } from '../input';

export default function FileField({ label, className, ...props }: ComponentProps<'input'> & { label: string }) {
	const field = useFieldContext<File | undefined>();
	const isOptional = useIsFieldOptional(field.name);

	return (
		<div className={className}>
			<div className="grid gap-2">
				{label && (
					<FieldLabelRow
						label={label}
						htmlFor={field.name}
						hasError={field.state.meta.isTouched && !field.state.meta.isValid}
						optional={isOptional}
					/>
				)}
				<Input
					type="file"
					id={field.name}
					name={field.name}
					aria-invalid={hasFieldError(field.state.meta)}
					ref={(ref) => {
						if (!ref) return;
						if (!field.state.value) return;
						if (!(field.state.value instanceof File)) return;

						// Create FileList so we can restore persisted file on input
						const dataTransfer = new DataTransfer();
						dataTransfer.items.add(field.state.value);
						ref.files = dataTransfer.files;
					}}
					onChange={(event) => {
						const file = event.target.files?.[0];

						field.handleChange(file);
						if (!file) return;
					}}
					{...props}
				/>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
